import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import FilePopup from "../PopUp/FilePopup";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { BsFillFileEarmarkWordFill } from "react-icons/bs";
import { SiMicrosoftexcel, SiMicrosoftpowerpoint } from "react-icons/si";
import { Card, Checkbox } from "@mui/material";
import { downloadFile } from "../..";
import No_BG from "assets/images/NoImage/no-image-available.png";
import { BtnDelete } from "components/Button/ButtonAll";
import { Extension, OpenNewTab } from "utilities/utilities";
import { TextBoxItem } from "components/Input/TextBox";
import { FormProvider, useForm } from "react-hook-form";
import { TextAreaItem } from "components/Input/TextArea";
import AutoCompleteInTable from "components/DataGrid/AutoCompleteInTable";
import { convertBytesToMegabyte } from "components/ConvertData/ConvertData";

const ItemCardRow = (props) => {
	const {
		IsCrop,
		cropShape,
		cropRatio,
		cropResize,
		cropMovable,
		IsHide = false,
	} = props;

	const {
		IsMultiDelete,
		disabled,
		IsHiddenUploadBox,
		SendCropImage,
		handleClick,
		isSelected,
		sPopup,
	} = props;

	const form = useForm({
		shouldFocusError: true,
		shouldUnregister: false,
		mode: "all",
	});

	const [arrOrder, setArrOrder] = useState([]);
	const [IsopenPopUp, setIsopenPopUp] = useState(false);

	const ClosePopUp = () => {
		setIsopenPopUp(false);
	};
	const OpenPopUp = useCallback(() => {
		setIsopenPopUp(true);
		if (props.onOpenFile) {
			props.onOpenFile(props.sFile_ID);
		}
	}, [props]);

	const onDownload = () => {
		downloadFile(props.sCropFileLink, props.sFileName)
	};

	const onClickFile = () => {
		if (sPopup === "newtab") {
			OpenNewTab(props.sCropFileLink);
		} else {
			if (props.onOpenFile) {
				props.onOpenFile(props.sFile_ID);
			}
			let isCheck =
				Extension.Image.indexOf(props.sFileType.toLowerCase()) > -1 ||
				Extension.Video.indexOf(props.sFileType.toLowerCase()) > -1
			isCheck ? OpenPopUp() : onDownload();
		}
	};

	const handdleOrderCard = (nOrder) => {
		props.setDeleteOrder(nOrder);
	}

	const sProgress = useMemo(() => {
		let sTextprogress = "";
		if (props.sProgress) {
			sTextprogress = props.sProgress + "%";
		}
		else {
			sTextprogress = props.IsCompleted ? "100%" : "";
		}
		return sTextprogress;
	}, [props.IsCompleted, props.sProgress])

	const handleChageOrder = (newValue, oldValue) => {
		//change order
		let nNewOrder = +newValue
		let isOldMoreThanNew = oldValue > nNewOrder;
		let nSetOrder = isOldMoreThanNew ? nNewOrder : oldValue;

		props.arrFile.forEach(item => {
			if (isOldMoreThanNew) {
				if (oldValue > item.nOrder && nNewOrder <= item.nOrder) {
					item.nOrder = ++nSetOrder;
				}
			} else {
				if (nNewOrder > item.nOrder && oldValue <= item.nOrder) {
					item.nOrder = nSetOrder++;
				}

				if (nNewOrder >= oldValue && nNewOrder === item.nOrder) {
					item.nOrder = oldValue;
				}
			}

			let nID = props.nID;
			if (props.nID === 0) {
				nID = props.nIndex + 1;
			}

			if (nID === item.nID) {
				item.nOrder = nNewOrder;
			}
		});

		props.arrFile.sort((a, b) => a.nOrder - b.nOrder);
		props.SetarrFile(props.arrFile);
	}

	useEffect(() => {
		form.setValue("sNameForDisplay-" + props.sFile_ID, props.sNameForDisplay ?? null);
		form.setValue("sNameFileDescription-" + props.sFile_ID, props.sNameFileDescription ?? null);

		var arrConvert = [];
		for (let i = 1; i <= props.arrFile.length; i++) {
			let obj = {
				value: i,
				label: i,
			};
			arrConvert.push(obj);
		}
		setArrOrder(arrConvert);
		let nNewID = 1;
		props.arrFile.forEach(f => {
			if ((f.nID === undefined || f.nID === 0) && f.IsNew) {
				f.nID = nNewID;
				let newOrder = nNewID; //props.nIndex + 1
				f.nOrder = newOrder;
			} else if (f.nID === 1 && f.IsNew) {
				f.nID = nNewID;
				let newOrder = nNewID;
				f.nOrder = newOrder;
			} else if (f.nID !== 1 && f.IsNew) {
				f.nID = nNewID;
				let newOrder = nNewID;
				f.nOrder = newOrder;
			}

			nNewID++;
		});

		props.arrFile.sort((a, b) => a.nOrder - b.nOrder);
	}, [props.arrFile, props.nOrder])

	return (
		<Fragment>
			<FormProvider {...form}>
				<Card sx={{ p: "1%", my: "2%", backgroundColor: "#ebe4d0" }}>
					<Grid container justifyContent={"space-between"} sx={{ display: "flex" }}>
						<Grid item xs={6} sm={2} md={1.5} lg={1} sx={{ display: "flex", alignItems: "center" }}>
							<AutoCompleteInTable
								small
								fullWidth
								objValue={{
									label: props.nOrder,
									value: props.nOrder
								}}
								funcOnChange={(newValue: any) => {
									handleChageOrder(newValue.target.innerText, (props.nIndex + 1));
								}}
								lstOption={arrOrder}
								disClearable
								disabled={disabled}
							/>
						</Grid>

						<Grid item sx={{ display: "flex" }}>
							{!IsHide && (
								<>
									{IsMultiDelete ? (
										<Grid item>
											{props.IsCompleted &&
												!disabled &&
												!IsHiddenUploadBox ? (
												<Checkbox
													color="primary"
													checked={isSelected(props.sFile_ID)}
													onClick={(event) => {
														handleClick(props.sFile_ID);
													}}
												/>
											) : null}
										</Grid>
									) : (
										<Grid item>
											{props.IsCompleted &&
												!props.disabled &&
												!props.IsHiddenUploadBox ? (
												<BtnDelete
													id={`delete-ontable-${props.sFile_ID}`}
													IsCircleWithOutText
													onClick={() => {
														props.onDelete(props.sFile_ID);
														handdleOrderCard(props.nOrder);
													}}
												/>
											) : (
												<></>
											)}
										</Grid>
									)}
								</>
							)}
						</Grid>
					</Grid>
					<Grid
						container
						justifyContent="flex-start"
						alignItems="center"
						spacing={2}
						className={"mui-style-FileItem"}
						sx={{ position: "relative", paddingBottom: IsHide ? "5px" : "10px" }}
					>
						<Grid item className={"mui-style-ColumnThumbnail"} onClick={onClickFile} sx={{ cursor: "pointer" }}>
							{DisplaySubFile(props, onClickFile)}
						</Grid>

						{/* picture detail */}
						<Grid container className={"mui-style-ColumnTitle-card-uploadFile"} sx={{ mt: "4%" }}>
							<Grid item xs={4} sm={3} md={4} lg={3}>
								<Typography className={"mui-style-Title-700"} sx={{ mb: "12%" }}>
									ชื่อไฟล์:
								</Typography>
								<Typography className={"mui-style-Title-700"} sx={{ mb: "7%" }}>
									ชื่อสำหรับแสดง:
								</Typography>
								<Typography className={"mui-style-Title-700"} sx={{ mb: "7%" }}>
									ขนาดไฟล์:
								</Typography>
								<Typography className={"mui-style-Title-700"}>
									รายละเอียดเพิ่มเติม:
								</Typography>
							</Grid>
							<Grid item xs={8} sm={9} md={8} lg={9}>
								<Typography className={"mui-style-Title mui-style-Title-color"} onClick={onClickFile} sx={{ mb: "2%" }}>
									{props.sFileName}
								</Typography>
								<Typography className={"mui-style-Title mui-style-Title-color"} sx={{ mb: "2%" }}>
									<TextBoxItem
										name={"sNameForDisplay-" + props.sFile_ID}
										maxLength={200}
										id={"sNameForDisplay-" + props.sFile_ID}
										required={true}
										type={'text'}
										disabled={disabled}
										sx={{ width: "87%" }}
										onChange={(e) => {
											form.setValue("sNameForDisplay-" + props.sFile_ID, e.target.value);
											props.arrFile.filter((f) => f.sFile_ID === props.sFile_ID).forEach(f => { f.sNameForDisplay = e.target.value; });
										}}
									/>
								</Typography>
								<Typography className={"mui-style-Title mui-style-Title-color"} sx={{ mb: "2%" }}>
									{/* convert bytes to mb in 2 digits decimal */}
									{convertBytesToMegabyte(props.nSize) + " MB"}
								</Typography>
								<Typography className={"mui-style-Title mui-style-Title-color"}>
									<TextAreaItem
										name={"sNameFileDescription-" + props.sFile_ID}
										maxLength={200}
										id={"sNameFileDescription-" + props.sFile_ID}
										required={true}
										disabled={disabled}
										row={3}
										style={{ width: "87%" }}
										onChange={(e) => {
											form.setValue("sNameFileDescription-" + props.sFile_ID, e.target.value);
											props.arrFile.filter((f) => f.sFile_ID === props.sFile_ID).forEach(f => { f.sNameFileDescription = e.target.value; });
										}}
									/>
								</Typography>
							</Grid>
						</Grid>
						{!IsHide && (
							<>
								{props.sProgress === "100" ? (
									<Grid item>
										{/* <CheckCircleIcon className="icon-pass" /> */}
									</Grid>
								) : (
									<Grid item xs={12}>
										<Box
											display="flex"
											alignItems="center"
											style={{
												display:
													props.IsHiddenUploadBox &&
														(props.sProgress === "100" ||
															props.sProgress === undefined)
														? "none"
														: "block",
											}}
										>
											<Box width="100%" mr={1}>
												<LinearProgress
													variant="determinate"
													value={
														parseInt(props.sProgress) || 100
													}
												/>
											</Box>
											<Box minWidth={40}>
												<Typography
													variant="body2"
													color="textSecondary"
												>
													{sProgress}
												</Typography>
											</Box>
										</Box>
									</Grid>
								)}
							</>
						)}
					</Grid>
					<FilePopup
						file={props}
						IsopenPopUp={IsopenPopUp}
						ClosePopUp={ClosePopUp}
						IsCrop={IsCrop}
						cropShape={cropShape}
						cropRatio={cropRatio}
						cropResize={cropResize}
						cropMovable={cropMovable}
						SendCropImage={SendCropImage}
						setStartVideoOn={props.setStartVideoOn}
						nStartVideoOn={props.nStartVideoOn}
						CannotSkipForward={props.CannotSkipForward}
						onVideoEnd={props.onVideoEnd}
						onDelete={props.onDelete}
						sPopup={sPopup}
					/>
				</Card>
			</FormProvider>
		</Fragment>
	);
};

export default ItemCardRow;

function DisplaySubFile(props: any, onClickFile: () => void) {

	const onImageError = (e) => {
		e.target.src = No_BG;
	}

	return (
		<>
			{Extension.Image.indexOf(props.sFileType.toLowerCase()) > -1 ?
				<Fragment>
					<img
						src={
							props.sCropFileLink && props.sCropFileLink.search("http") > -1
								? props.sCropFileLink
								: process.env.REACT_APP_API_URL +
								props.sCropFileLink || ""
						}
						alt=""
						width={300}
						height={200}
						onError={onImageError}
						style={{ borderRadius: "10%", margin: "8px", padding: 0 }}
					/>
				</Fragment>
				: null}

			{Extension.Video.indexOf(props.sFileType.toLowerCase()) > -1 ? (
				<Tooltip title="">
					<IconButton
						className={"mui-style-WordColor"}
						size="small"
						onClick={onClickFile}
					>
						<VideoLibraryIcon className={"mui-style-IConColor"} />
					</IconButton>
				</Tooltip>
			) : null}

			{Extension.PDF.indexOf(props.sFileType.toLowerCase()) > -1 ?
				<Tooltip title="">
					<IconButton
						className={"mui-style-PDFColor"}
						size="small"
						onClick={onClickFile}
					>
						<PictureAsPdfIcon className={"mui-style-IConColor"} />
					</IconButton>
				</Tooltip>
				: null}

			{Extension.Word.indexOf(props.sFileType.toLowerCase()) > -1 ?
				<Tooltip title="">
					<IconButton
						className={"mui-style-WordColor"}
						size="small"
						onClick={onClickFile}
					>
						<BsFillFileEarmarkWordFill
							className={"mui-style-IConColor"}
						/>
					</IconButton>
				</Tooltip>
				: null}

			{Extension.Excel.indexOf(props.sFileType.toLowerCase()) > -1 ?
				<Tooltip title="">
					<IconButton
						className={"mui-style-ExcelColor"}
						size="small"
						onClick={onClickFile}
					>
						<SiMicrosoftexcel className={"mui-style-IConColor"} />
					</IconButton>
				</Tooltip>
				: null}

			{Extension.PowerPoint.indexOf(props.sFileType.toLowerCase()) > -1 ?
				<Tooltip title="">
					<IconButton
						className={"mui-style-PowerPointColor"}
						size="small"
						onClick={onClickFile}
					>
						<SiMicrosoftpowerpoint className={"mui-style-IConColor"} />
					</IconButton>
				</Tooltip>
				: null}
		</>
	);
}